"use client";

import { useLocale } from "next-intl";
import { useCallback, useState } from "react";
import { BsTrash3Fill } from "react-icons/bs";
import { convertDate, generateIcon } from "utils";
import { deleteReservation } from "../services/reservationService";
import { Confirm } from "./confirm";
import { toastMessage } from "./toast";

export function DeleteReservationButton({
  reservation,
  disabled,
  refresh,
  t,
}: any) {
  const locale = useLocale();
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const handleDelete = useCallback(
    (_id: string) => {
      deleteReservation(_id)
        .then((resp) => {
          if (resp.data.success) {
            toastMessage.success(t("Toast.reservationDeleteSuccess"));
            refresh();
          } else {
            toastMessage.validationError(resp.data.validationErrors);
          }
        })
        .catch((error) =>
          toastMessage.error(t("Toast.errorDeleteReservation", error))
        );
    },
    // eslint-disable-next-line
    [reservation]
  );

  return (
    <>
      <button
        type="button"
        title={t(
          disabled
            ? "Reservation.deleteReservationDisabled"
            : "Reservation.deleteReservation"
        )}
        onClick={() => setShowConfirmation(true)}
        disabled={disabled}
        className="flex flex-row items-center ml-3 cursor-pointer"
      >
        {generateIcon(
          BsTrash3Fill,
          `w-[25px] h-[25px] ${disabled ? "tetx-gray-600" : "text-error"} `
        )}
      </button>
      <Confirm
        handleOk={() => {
          handleDelete(reservation.id);
          setShowConfirmation(false);
        }}
        handleClose={() => {
          setShowConfirmation(false);
        }}
        isOpened={showConfirmation}
        okBtnText={t("Buttons.delete")}
        title={t("Reservation.deleteConfirmTitle")}
        t={t}
      >
        <div className="flex flex-col gap-2 p-5">
          <Item
            title={t("Global.name")}
            value={`${reservation.firstName} ${reservation.lastName}`}
          />
          <Item title={t("Global.email")} value={reservation.email} />
          <Item
            title={t("Global.eventDate")}
            value={`${convertDate(reservation.eventStartTime, "utc", locale)} - ${convertDate(reservation.eventEndTime, "utc", locale)}`}
          />
        </div>
      </Confirm>
    </>
  );
}

function Item({ title, value }: { title: string; value: string }) {
  return (
    <div className="flex flex-row gap-3">
      <p className="text-base font-semibold">{title}:</p>
      <p className="text-base">{value}</p>
    </div>
  );
}
